import {
  GET_PLATFORM_SETTINGS,
  GET_PLATFORM_SETTINGS_SUCCESS,
  GET_PLATFORM_SETTINGS_ERROR,
} from "./actionTypes"

export const getPlatformSettings = () => ({
    type: GET_PLATFORM_SETTINGS,
})

export const getPlatformSettingsSuccess = (settings) => ({
  type: GET_PLATFORM_SETTINGS_SUCCESS,
  payload: settings
})

export const getPlatformSettingsError = (error) => ({
  type: GET_PLATFORM_SETTINGS_ERROR,
  payload: error
})